import Config from "../../common/config/config";

export default class KansoDOM {
    constructor() {
        this._init();
    }

    setBook(bookData) {
        this._updateBookDom(bookData);
    }

    setUser(userData) {
        this._updateUserDom(userData);
    }

    change(datas, isInit = false) {
        this.datas = datas;
        this._updateUserDom();
        this._updateDom();
    }

    reset() {
        this.$book.setAttribute("src", "");
        this.$usrName.innerHTML = "";
        this.$usrText.innerHTML = "";
        this.$title.innerHTML = "";
        this.$author.innerHTML = "";
        this.$publish.innerHTML = "";
        this.$excerpt.innerHTML = "";
        this.$tags.innerHTML = "";
    }

    _init() {
        this._setBaseDom();

        this.$self = document.querySelector(".kanso-sp");
        this.$usrName = this.$self.querySelector(".js-kanso-username");
        this.$usrText = this.$self.querySelector(".js-kanso-usertext");
        this.$book = this.$self.querySelector(".js-book");
        this.$readbtn = this.$self.querySelector(".kanso__readbtn");
        this.$tags = this.$self.querySelector(".js-kanso-tags");
        this.$title = this.$self.querySelector(".js-kanso-title");
        this.$author = this.$self.querySelector(".js-kanso-author");
        this.$publish = this.$self.querySelector(".js-kanso-publish");
        this.$excerpt = this.$self.querySelector(".js-kanso-excerpt");
    }

    _setBaseDom() {
        const tag = `
            <div class="kanso kanso-sp">
                <div class="kanso__inner">
                <div class="kanso__head">
                    <p class="kanso__username js-kanso-username"></p>
                    <p class="kanso__usertext js-kanso-usertext"></p>
                </div>
                <div class="kanso__main">
                    <ul class="kanso__tags js-kanso-tags">
                    </ul>
                    <p class="kanso__title js-kanso-title"></p>
                    <div class="kanso__book"><img src="" alt="" class="js-book"></div>
                    <p class="kanso__author js-kanso-author"></p>
                    <p class="kanso__publish js-kanso-publish"></p>
                    <div class="kanso__readbtn c-hover_op"><a href="#">ためし読み</a></div>
                    <p class="kanso__excerpt js-kanso-excerpt"></p>
                </div>
                <div class="kanso__prev c-hover_op js-kanso-prev"><span><img src="${Config.image_dir}top/kanso/btn_prev.png" alt="PREV"></span></div>
                <div class="kanso__next c-hover_op js-kanso-next"><span><img src="${Config.image_dir}top/kanso/btn_next.png" alt="NEXT"></span></div>
                <div class="kanso__close c-hover_op js-kanso-close"><span><img src="${Config.image_dir}top/kanso/btn_close.png" alt="閉じる"></span></div>
                </div>
            </div>`;

        document.body.insertAdjacentHTML("beforeend", tag);
    }

    _updateUserDom(userData) {
        this.$usrName.innerHTML = `${userData["学年"]}　${userData["ペンネーム"]}`;
        this.$usrText.innerHTML = userData["感想"];
    }

    _updateBookDom(bookData) {
        this.$book.setAttribute("src", bookData.bookfile);

        this.$title.innerHTML = bookData.title;
        // this.$author.innerHTML = `[作] ${bookData.author}`;
        this.$author.innerHTML = `${bookData.author}`;
        this.$publish.innerHTML = `[出版社] ${bookData.publish}`;
        this.$excerpt.innerHTML = bookData.excerpt;

        if (bookData.link == "") {
            this.$readbtn.style.display = "none";
        } else {
            this.$readbtn.style.display = "block";
            const envURL = document.querySelector(".js-envurl").getAttribute("href");
            this.$readbtn.querySelector("a").setAttribute("href", envURL + bookData.link);
        }

        for (let i = 0; i < bookData.tags.length; i++) {
            const tag = `<li class="kanso__tags__item">${bookData.tags[i]}</li>`;
            this.$tags.insertAdjacentHTML("beforeend", tag);
        }
    }
}
